"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var BackIcon_1 = __importDefault(require("./widgets/BackIcon"));
var reducers_1 = require("./util/reducers");
var __1 = require("..");
var DrawerMargin_1 = __importDefault(require("./DrawerMargin"));
var CloseIcon_1 = __importDefault(require("../../../../app/components/widgets/CloseIcon"));
var LinkAnalytics_1 = __importDefault(require("./LinkAnalytics"));
var LinkHistory_1 = __importDefault(require("./LinkHistory"));
var LinkHistoryButton_1 = __importDefault(require("./LinkHistory/LinkHistoryButton"));
var DrawerHeader_1 = __importDefault(require("./DrawerHeader"));
var shortlink_1 = __importDefault(require("./util/shortlink"));
var LinkInfoEditor_1 = __importDefault(require("../../../widgets/LinkInfoEditor"));
var LinkOwnershipField_1 = __importDefault(require("./widgets/LinkOwnershipField"));
var FileEditor_1 = __importDefault(require("./widgets/FileEditor"));
var TrailingButton_1 = __importDefault(require("./widgets/TrailingButton"));
var DownloadButton_1 = __importDefault(require("./widgets/DownloadButton"));
var LinkStateText_1 = __importDefault(require("./widgets/LinkStateText"));
var LongUrlEditor_1 = __importDefault(require("./widgets/LongUrlEditor"));
var TagsEditor_1 = __importDefault(require("./widgets/TagsEditor"));
var types_1 = require("../../../../app/util/types");
var actions_1 = __importDefault(require("../../../actions"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return core_1.createStyles({
        backButton: (_a = {
                position: 'absolute',
                top: 0,
                right: 'auto',
                left: 0,
                margin: 45,
                padding: 0,
                backgroundColor: 'transparent',
                '&:hover': {
                    backgroundColor: 'transparent',
                }
            },
            _a[theme.breakpoints.down('md')] = {
                marginLeft: theme.spacing(4),
                marginRight: theme.spacing(4),
            },
            _a),
        backButtonText: {
            paddingLeft: 10,
        },
        drawerPaper: {
            width: '100%',
            height: '100%',
            maxWidth: theme.breakpoints.width('md'),
        },
        dialogContents: (_b = {
                marginTop: theme.spacing(9)
            },
            _b[theme.breakpoints.up('md')] = {
                marginTop: 116,
            },
            _b),
        closeIcon: (_c = {
                position: 'absolute',
                top: 0,
                right: theme.spacing(0),
                left: 'auto',
                margin: theme.spacing(2)
            },
            _c[theme.breakpoints.up('md')] = {
                left: 0,
                margin: 30,
                right: 'auto',
            },
            _c),
        divider: (_d = {
                marginTop: 50,
                marginBottom: 50
            },
            _d[theme.breakpoints.up('md')] = {
                marginTop: 80,
                marginBottom: 68,
            },
            _d),
        dividerAnalytics: (_e = {
                marginTop: 50,
                marginBottom: 50
            },
            _e[theme.breakpoints.up('md')] = {
                marginTop: 50,
                marginBottom: 68,
            },
            _e),
        dividerInformation: (_f = {
                marginTop: 50,
                marginBottom: 50
            },
            _f[theme.breakpoints.up('md')] = {
                marginTop: 73,
                marginBottom: 50,
            },
            _f),
        regularText: {
            fontWeight: 400,
        },
        topBar: {
            width: '100%',
            height: 110 + 33 + 33,
            /* 66 px for copy button's height and link history button */
            boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.1)',
            backgroundColor: theme.palette.background.default,
            position: 'absolute',
            top: 0,
            zIndex: -1,
        },
        textFieldsTopSpacer: {
            height: theme.spacing(1),
        },
        saveLinkInformationButtonWrapper: (_g = {
                display: 'flex',
                justifyContent: 'flex-end',
                flexDirection: 'column'
            },
            _g[theme.breakpoints.up('md')] = {
                flexDirection: 'row',
                paddingTop: 9,
            },
            _g),
        previewButton: (_h = {
                '&:hover': {
                    textDecoration: 'none',
                },
                marginBottom: theme.spacing(1)
            },
            _h[theme.breakpoints.up('md')] = {
                marginRight: theme.spacing(1),
                marginBottom: 0,
            },
            _h),
        inactiveDesc: {
            display: 'none',
        },
    });
});
function ControlPanel() {
    // Styles used in this component.
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isMobileView = core_1.useMediaQuery(theme.breakpoints.down('sm'));
    // Modal controller.
    var drawerStates = __1.useDrawerState();
    var drawerIsOpen = drawerStates.controlPanelIsOpen;
    var modalDispatch = __1.useDrawerDispatch();
    var dispatch = react_redux_1.useDispatch();
    // Fetch short link state and dispatches from redux store through our helper hook.
    var _a = shortlink_1.default(drawerStates.relevantShortLink), shortLinkState = _a.shortLinkState, shortLinkDispatch = _a.shortLinkDispatch;
    // Toggle Link History
    var isLinkHistoryActive = drawerStates.linkHistoryIsActive;
    var toggleLinkHistory = function () {
        return modalDispatch({ type: reducers_1.DrawerActions.activateLinkHistory });
    };
    // Manage values in our text fields.
    var editedContactEmail = (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.editedContactEmail) || '';
    var editedDescription = (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.editedDescription) || '';
    var originalDescription = (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.description) || '';
    var originalContactEmail = (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.contactEmail) || '';
    var _b = __read(react_1.useState(Boolean(originalContactEmail)), 2), isContactEmailValid = _b[0], setContactEmailValid = _b[1];
    var _c = __read(react_1.useState(Boolean(originalDescription)), 2), isDescriptionValid = _c[0], setDescriptionValid = _c[1];
    // Disposes any current unsaved changes and closes the modal.
    var handleClose = function () {
        shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.setEditDescription(originalDescription);
        shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.setEditContactEmail(originalContactEmail);
        modalDispatch({ type: reducers_1.DrawerActions.closeControlPanel });
        dispatch(actions_1.default.resetLinkHistory());
    };
    return (react_1.default.createElement(core_1.Drawer, { classes: {
            paper: classes.drawerPaper,
        }, anchor: isMobileView ? 'bottom' : 'right', open: drawerIsOpen, onClose: handleClose },
        react_1.default.createElement("main", { className: classes.dialogContents },
            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                react_1.default.createElement("div", { className: classes.topBar })),
            !isLinkHistoryActive && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.IconButton, { className: classes.closeIcon, onClick: handleClose },
                    react_1.default.createElement(CloseIcon_1.default, null)),
                react_1.default.createElement(DrawerMargin_1.default, null,
                    react_1.default.createElement(LinkHistoryButton_1.default, { clickHandler: toggleLinkHistory }),
                    react_1.default.createElement(DrawerHeader_1.default, { title: "Edit Link" }),
                    react_1.default.createElement(LinkStateText_1.default, null),
                    react_1.default.createElement(DownloadButton_1.default, null),
                    react_1.default.createElement(core_1.Hidden, { smDown: true },
                        react_1.default.createElement("div", { className: classes.textFieldsTopSpacer })),
                    react_1.default.createElement(core_1.Hidden, { mdUp: true },
                        react_1.default.createElement(core_1.Divider, { className: classes.divider })),
                    (shortLinkState === null || shortLinkState === void 0 ? void 0 : shortLinkState.isFile) ? react_1.default.createElement(FileEditor_1.default, null) : react_1.default.createElement(LongUrlEditor_1.default, null),
                    react_1.default.createElement(core_1.Hidden, { mdUp: true },
                        react_1.default.createElement(core_1.Divider, { className: classes.divider })),
                    react_1.default.createElement(LinkOwnershipField_1.default, { closeModal: handleClose }),
                    react_1.default.createElement(core_1.Hidden, { mdUp: true },
                        react_1.default.createElement(core_1.Divider, { className: classes.divider })),
                    react_1.default.createElement(TagsEditor_1.default, null),
                    react_1.default.createElement("div", { className: classes.inactiveDesc },
                        react_1.default.createElement(core_1.Divider, { className: classes.dividerInformation }),
                        react_1.default.createElement(LinkInfoEditor_1.default, { contactEmail: editedContactEmail, description: editedDescription, onContactEmailChange: function (event) {
                                return shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.setEditContactEmail(event.target.value);
                            }, onDescriptionChange: function (event) {
                                return shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.setEditDescription(event.target.value.replace(/(\r\n|\n|\r)/gm, ''));
                            }, onContactEmailValidation: setContactEmailValid, onDescriptionValidation: setDescriptionValid }),
                        react_1.default.createElement("div", { className: classes.saveLinkInformationButtonWrapper },
                            react_1.default.createElement(core_1.Link, { target: "_blank", href: isDescriptionValid &&
                                    isContactEmailValid &&
                                    editedDescription
                                    ? "/#" + types_1.SEARCH_PAGE
                                    : undefined, className: classes.previewButton },
                                react_1.default.createElement(TrailingButton_1.default, { disabled: !originalDescription ||
                                        originalDescription !== editedDescription, fullWidth: isMobileView, variant: "outlined" }, "Preview")),
                            react_1.default.createElement(TrailingButton_1.default, { disabled: !isDescriptionValid ||
                                    (editedContactEmail === originalContactEmail &&
                                        editedDescription === originalDescription) ||
                                    !isContactEmailValid, fullWidth: isMobileView, variant: isMobileView ? 'contained' : 'outlined', onClick: shortLinkDispatch === null || shortLinkDispatch === void 0 ? void 0 : shortLinkDispatch.applyEditInformation }, "Save"))),
                    react_1.default.createElement(core_1.Divider, { className: classes.dividerAnalytics }),
                    react_1.default.createElement(LinkAnalytics_1.default, null)))),
            isLinkHistoryActive && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Button, { className: classes.backButton, onClick: toggleLinkHistory, size: "large", variant: "text", color: "primary" },
                    react_1.default.createElement(BackIcon_1.default, { color: theme.palette.primary.main }),
                    react_1.default.createElement(core_1.Typography, { variant: "h6", className: classes.backButtonText }, "Back to Edit link")),
                react_1.default.createElement(DrawerMargin_1.default, null,
                    react_1.default.createElement(DrawerHeader_1.default, { title: "Link History" }),
                    react_1.default.createElement(LinkHistory_1.default, null)))))));
}
exports.default = ControlPanel;
